bovoApp.controller('MarketplaceOrderMapController', ['$scope', 'Marketplace',
    function ($scope, Marketplace) {
        $scope.f = { provider: 'all', integration_id: '', match_status: 'all', external_status: '', bovo_ref: '', term: '', days: 7 };
        $scope.data = { data: [], total: 0, current_page: 1, last_page: 1, stats: {} };
        $scope.integrations = [];
        $scope.selected = null;
        $scope.loading = false;
        $scope.manualOrderId = '';

        $scope.load = function (page) {
            var params = angular.copy($scope.f);
            if (page) params.page = page;
            if (params.provider === 'all') delete params.provider;
            if (params.match_status === 'all') delete params.match_status;
            if (!params.integration_id) delete params.integration_id;
            if (!params.term) delete params.term;
            if (!params.external_status) delete params.external_status;
            if (!params.bovo_ref) delete params.bovo_ref;

            $scope.loading = true;
            Marketplace.orderMaps(params).success(function (res) {
                $scope.data = res;
                $scope.loading = false;
            }).error(function () {
                $scope.loading = false;
            });
        };

        $scope.goToPage = function (page) {
            $scope.load(page);
        };

        $scope.loadIntegrations = function () {
            Marketplace.integrations({}).success(function (res) {
                $scope.integrations = (res.data || []);
            });
        };

        // Detay
        $scope.showDetail = function (item) {
            Marketplace.orderMap(item.id).success(function (res) {
                $scope.selected = res.data;
                $scope.manualOrderId = '';
                $('#orderMapModal').modal('show');
            });
        };

        // Otomatik Rematch
        $scope.rematch = function (item) {
            var target = item || $scope.selected;
            if (!target) return;
            target._busy = true;
            Marketplace.rematch(target.id).success(function (res) {
                target._busy = false;
                Messenger().post(res.message || 'Islem tamam');
                angular.extend(target, res.data);
                if ($scope.selected && $scope.selected.id === target.id) {
                    angular.extend($scope.selected, res.data);
                }
            }).error(function (res) {
                target._busy = false;
                Messenger().post({ message: (res && res.message) || 'Rematch hatasi', type: 'error' });
            });
        };

        // Manuel Eşleştirme (order_id ile)
        $scope.manualMatch = function () {
            if (!$scope.selected) return;
            var orderId = $scope.manualOrderId ? parseInt($scope.manualOrderId) : null;
            Marketplace.manualMatch($scope.selected.id, orderId).success(function (res) {
                Messenger().post(res.message || 'Islem tamam');
                angular.extend($scope.selected, res.data);
                $scope.load($scope.data.current_page);
            }).error(function (res) {
                Messenger().post({ message: (res && res.message) || 'Eslesme hatasi', type: 'error' });
            });
        };

        // Eşleşmeyi kaldır
        $scope.unmatch = function () {
            if (!$scope.selected) return;
            Marketplace.manualMatch($scope.selected.id, null).success(function (res) {
                Messenger().post(res.message || 'Eslesme kaldirildi');
                angular.extend($scope.selected, res.data);
                $scope.load($scope.data.current_page);
            }).error(function (res) {
                Messenger().post({ message: (res && res.message) || 'Hata', type: 'error' });
            });
        };

        $scope.matchLabel = function (s) {
            switch (s) {
                case 'matched':    return 'Eşli';
                case 'unmatched':  return 'Eşleşmedi';
                case 'mismatched': return 'Uyumsuz';
                default:           return s;
            }
        };

        $scope.init = function () {
            $scope.loadIntegrations();
            $scope.load();
        };
    }
]);
